import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AREA_BUILDING_TABLE_ITEM } from 'src/app/pages/main/module/engineering-application/components/constant/My-data';
import { ListItemData } from 'src/app/pages/main/module/model/listitem-data';
import { VwFindSigndataControllerService } from 'src/app/sdk/services';
import { VwFindMyFormService } from '../api/vw-find-my-form.service';

@Injectable({
  providedIn: 'root'
})
export class GetSignDataService {
  totallistItem = [];
  total: number;
  countStatusData: SignStatus = {};
  countStatusDataByProjectType = {
    0: {},
    1: {}
  };
  listItem: ListItemData[] = [];
  pageSize: number = 7;

  constructor(
    private vwFindSigndata: VwFindSigndataControllerService,
    private vwFindMyFormService: VwFindMyFormService,
    private translateService: TranslateService
  ) { }
  // 获取不同步骤和状态下的单据数量
  async getStepStatusCount(obj: object) {
    //obj = { userid: this.userid, step: this.step, status: 1, projectCategory?: this.projectType }
    let result = {};
    let stepStatusCount: number = 0;
    let param = {
      "status": obj['status'],
      "emplid": obj['userid'],
      "signStep": obj['step']
    }
    // 我的单据
    if (obj['step'] === 0) {
      delete param.signStep;
      result = await this.vwFindMyFormService.findMyFormData(param);
    }
    else {
      result = await this.vwFindSigndata.findSignData({ body: param }).toPromise();
    }
    if (!!result[0]) {
      if (obj['projectCategory'] !== undefined) {
        Object.keys(result[0]).forEach(key => {
          /* 
            projectCategory=0是一般工程,一般工程-->概算审核
            projectCategory=1是专案工程,专案工程-->标单审核 
          */
          if (result[0][key]['formApplyDetail']['projectCategory'] === obj['projectCategory']) {
            stepStatusCount++;
          }
        });
      }
      else {
        stepStatusCount = Object.keys(result[0]).length;
      }
    }
    return stepStatusCount;
  }

  // 获取单据
  async getSignData(param: InputPramData, projectType?: number) {
    let result = {};
    if (!param['signStep']) {
      result = await this.vwFindMyFormService.findMyFormData(param);
    }
    else {
      result = await this.vwFindSigndata.findSignData({ body: param }).toPromise();
    }
    this.totallistItem = [];
    this.countStatusData = {};
    this.total = 0;
    this.listItem = [];
    let outputData: OutputSignData = {
      "totallistItem": this.totallistItem,
      "total": this.total,
      "countStatusData": this.countStatusData,
      "listItem": this.listItem,
      "pageSize": this.pageSize,
      "countStatusDataByProjectType": {}
    }
    if (JSON.stringify(result) !== "{}") {
      // 遍历单据.key=单号
      Object.keys(result[0]).forEach(key => {
        let tableItem = { ...AREA_BUILDING_TABLE_ITEM };
        tableItem.signStatus = [];
        tableItem.applicant = result[0][key]['applicant'];
        tableItem.applicant.formid = key;
        tableItem.applicant.version = result[0][key]['formApplyDetail']['version'];
        // 获取表单详细信息
        let formApplyDetail = JSON.parse(JSON.stringify(result[0][key]['formApplyDetail']));
        // 获取表单中的需求描述
        let descripption = formApplyDetail['description'];
        // 地点 = garden + area + building + floor + functionRoom + roomNumber
        let site = formApplyDetail['garden'] + formApplyDetail['area'] + formApplyDetail['building']
          + " " + formApplyDetail['floor'] + " " + formApplyDetail['functionRoom'] + formApplyDetail['roomNumber'];

        // 空数组连接result[0][key]['signStatus']
        tableItem.signStatus = result[0][key]['signStatus'].length > 2 ? JSON.parse(JSON.stringify(result[0][key]['signStatus'].splice(0, 2))) : JSON.parse(JSON.stringify(result[0][key]['signStatus']));
        if (tableItem.signStatus.length > 0) {
          const civilOrElectroArr = [];
          tableItem.signStatus.forEach((obj, index) => {
            // 工程分类是否已存在,存在则删除tableItem.signStatus的最后一项,不存在则做以下处理
            if (!civilOrElectroArr.includes(tableItem.signStatus[index]['civilOrElectro'])) {
              civilOrElectroArr.push(obj['civilOrElectro']);
              // 需求描述
              tableItem.signStatus[index]['descripption'] = index === 0 ? descripption : "";
              // 地点 
              tableItem.signStatus[index]['site'] = index === 0 ? site : "";
              // 工程分类
              tableItem.signStatus[index]['classfication'] = obj['civilOrElectro'] === 0 ? this.translateService.instant('DetailInfo.CIVIL') : this.translateService.instant('DetailInfo.ELECTRO');
              // stopDays
              tableItem.signStatus[index]['stopDays'] = tableItem.signStatus[index]['stopDays'] >= 0 ? tableItem.signStatus[index]['stopDays'] : null;
              // 我的单据--已完成/已取消不显示Target 停留 Status
              if (!param['signStep'] && (param['status'] === -1 || param['status'] === 1)) {
                tableItem.signStatus[index]['statusValue'] = param['status'] === 1 ? this.translateService.instant('Common.Closed') : this.translateService.instant('Common.ApplicantCanceled');
                tableItem.signStatus = this.delOthersAttribute(tableItem.signStatus);
              }
              // 厂务助理已取消不显示停留
              else if (param['signStep'] === 11 && param['status'] === -1 || param['status'] === -4) {
                tableItem.signStatus[index]['statusValue'] = this.translateService.instant('Common.FacAssistantCancelled');
                tableItem.signStatus = this.delOthersAttribute(tableItem.signStatus);
              }
            }
            else {
              tableItem.signStatus.pop();
            }
          });
        }
        else {
          tableItem.signStatus.push(JSON.parse(JSON.stringify({ "statusValue": "", "descripption": descripption, "site": site })));
        }

        // 将tableItem追加到totallistItem[]中
        if ((param['signStep'] >= 7 && param['signStep'] <= 10) && projectType >= 0) {//如果是步骤7/8/9/10,则要根据专案分类来分成标单审核和概算审核
          if (formApplyDetail['projectCategory'] === projectType) {
            this.totallistItem.push(tableItem);
            // 单据总数量+1
            this.total++;
          }
        }
        else {
          this.totallistItem.push(tableItem);
          // 单据总数量+1
          this.total++;
        }
      });
      // 显示的listItem为totallistItem的pageSize条
      this.listItem = this.totallistItem.slice(0, this.pageSize);
      // 统计不同标单制定状态的单据数量
      if ((param['signStep'] >= 7 && param['signStep'] <= 10) && projectType >= 0) {
        if (param.status === 0) {
          this.countStatusDataByProjectType[projectType]['waitting'] = this.total;
        }
        if (param.status === 1) {
          this.countStatusDataByProjectType[projectType]['signed'] = this.total;
        }
      }
      else if (param['signStep'] === 11) {
        if (param.status === 0) {
          this.countStatusData['waittingPR'] = this.total;
        }
        if (param.status === -1) {//厂务助理询价--已取消
          this.countStatusData['cancel'] = this.total;
        }
      }
      else if (param['signStep'] === 12) {
        this.countStatusData['ongoingPR'] = this.total;
      }
      else if (param['signStep'] === 13) {
        this.countStatusData['waittingPO'] = this.total;
      }
      else if (param.status === -1) {
        this.countStatusData['cancel'] = this.total;
      }
      else if (param.status === 0) {
        this.countStatusData['waitting'] = this.total;
      }
      else if (param.status === 1) {
        this.countStatusData['signed'] = this.total;
      }
      else if (param.status === -4) {
        this.countStatusData['facAssistantCanceled'] = this.total;
      }
      else if (param['signStep'] !== 11 && (param.status === 2 || param.status === -2)) {
        this.countStatusData['reject'] = this.total;
      }

      outputData = {
        "totallistItem": this.totallistItem,
        "total": this.total,
        "countStatusData": this.countStatusData,
        "countStatusDataByProjectType": this.countStatusDataByProjectType,
        "listItem": this.listItem,
        "pageSize": this.pageSize
      }
    }
    return outputData;
  }
  delOthersAttribute(signStatus: Array<object>) {
    // 删除多余的属性
    for (let obj of signStatus) {
      Object.keys(obj).forEach(key => {
        if (!(['classfication', 'descripption', 'site', 'statusValue'].includes(key))) {
          delete obj[key];
        }
      });
    }
    return signStatus;
  }
}

export interface InputPramData {
  "status": number,
  "emplid": string,
  "signStep"?: number
}

export interface OutputSignData {
  "totallistItem": Array<any>,
  "total": number,
  "countStatusData": SignStatus,
  "countStatusDataByProjectType": Object,
  "listItem": ListItemData[],
  "pageSize": number,
}

export interface SignStatus {
  waitting?: number,
  reject?: number,
  signed?: number,
  cancel?: number,
  facAssistantCanceled?: number,
  waittingPR?: number,
  ongoingPR?: number,
  waittingPO?: number,
  onGoingPO?: number,
  signedPO?: number
}